module.exports = __webpack_public_path__ + "images/banners/pasodash/note_pc_dash_banner_0a062a3883e274b68b12a1ce0061c227.png";